import { render } from "./ClientList.vue?vue&type=template&id=fe8faa04&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=fe8faa04&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8faa04"]])

export default __exports__